import { cmsApiFetchPage } from 'modules/cms/api/cmsApiFetchPage';
import { CmsContentPageLoadable } from 'modules/cms/containers/ContentPage/CmsContentPageLoadable';
import { getCmsSearchLandingPagePageLayoutHandleProps } from 'modules/cms/helpers/getCmsSearchLandingPagePageLayoutHandleProps';
import { CmsPagePageLoadable } from 'modules/cms/pages/Page/CmsPagePageLoadable';
import { getCmsPagePageLayoutHandleProps } from 'modules/cms/pages/Page/getCmsPagePageLayoutHandleProps';
import { CmsPostPageLoadable } from 'modules/cms/pages/Post/CmsPostPageLoadable';
import { getCmsPagePostLayoutHandleProps } from 'modules/cms/pages/Post/getCmsPagePostLayoutHandleProps';
import { PostSearchPageLoadable } from 'modules/postSearch/pages/PostSearch/PostSearchPageLoadable';
import { getPostSearchPageLayoutHandleProps } from 'modules/postSearch/pages/PostSearch/getPostSearchPageLayoutHandleProps';
import { SearchLandingPageLoadable } from 'modules/search/pages/Landing/SearchLandingPageLoadable';
import { TypedLoaderFunctionArgs } from 'routing/utils/types/TypedLoaderFunctionArgs';

import { CmsPageLoaderData } from './CmsPageLoaderData';

export async function cmsPageLoader({
  request,
  params,
}: TypedLoaderFunctionArgs<'*'>): Promise<CmsPageLoaderData> {
  const slugParam = params['*'] as string;
  const slug = (
    slugParam.startsWith('/amp') ? slugParam.replace('/amp', '') : slugParam
  ).replace('events', 'volunteer');

  const { searchParams } = new URL(request.url);

  const storeState = global.store.getState();
  const loggedIn = Boolean(storeState.userEnvironment.user);

  try {
    const content = await cmsApiFetchPage(slug);

    if (content.type === 'SEARCH_LANDING_PAGE') {
      await SearchLandingPageLoadable.load();
      return {
        type: 'SEARCH_LANDING_PAGE',
        content,
        isSsr: typeof global.window === 'undefined',
        handle: getCmsSearchLandingPagePageLayoutHandleProps({ content }),
      };
    }

    if (searchParams.has('pq')) {
      await PostSearchPageLoadable.load();
      return {
        type: 'POST_SEARCH',
        content,
        handle: getPostSearchPageLayoutHandleProps({ content }),
      };
    }

    if (content.type === 'PAGE') {
      await Promise.all([
        CmsContentPageLoadable.load(),
        CmsPagePageLoadable.load(),
      ]);

      return {
        type: 'CONTENT',
        content,
        handle: getCmsPagePageLayoutHandleProps({ loggedIn, content }),
      };
    }

    // content.type === 'POST'
    await Promise.all([
      CmsContentPageLoadable.load(),
      CmsPostPageLoadable.load(),
    ]);

    return {
      type: 'CONTENT',
      content,
      handle: getCmsPagePostLayoutHandleProps({ loggedIn, content }),
    };
  } catch {
    return null;
  }
}
